/**
 * 沉浸模式：横屏手机上把顶栏和底栏收起来，只剩内容。
 *
 * 行为照视频播放器的惯例：
 *  · 三秒没操作，顶栏底栏自动隐藏；
 *  · 点一下内容区，隐藏 ⇄ 显示 切换；
 *  · 碰任何按钮都算「有操作」，重新计时。
 *
 * 用 click 而不是 pointerdown 判「点了一下内容区」：双指缩放、单指拖动
 * 都会发 pointerdown，但不会发 click —— 否则每次缩放白板都会把底栏弹出来。
 */

import { useEffect, useState } from 'react'

export function useImmersive(enabled: boolean, idleMs = 3000): boolean {
  const [hidden, setHidden] = useState(false)

  useEffect(() => {
    if (!enabled) {
      setHidden(false)
      return
    }
    let timer = 0
    const arm = () => {
      window.clearTimeout(timer)
      timer = window.setTimeout(() => setHidden(true), idleMs)
    }
    const isStage = (t: EventTarget | null) =>
      t instanceof Element && !!t.closest('.cr-stage, .wb-wrap')

    const onClick = (e: MouseEvent) => {
      if (isStage(e.target)) {
        setHidden((h) => !h)
        arm()
      }
    }
    const onAct = (e: Event) => {
      // 内容区上的操作交给 click 处理；这里只管别处（按钮、抽屉）
      if (isStage(e.target)) return
      setHidden(false)
      arm()
    }
    window.addEventListener('click', onClick)
    window.addEventListener('pointerdown', onAct, true)
    window.addEventListener('keydown', onAct, true)
    arm()
    return () => {
      window.clearTimeout(timer)
      window.removeEventListener('click', onClick)
      window.removeEventListener('pointerdown', onAct, true)
      window.removeEventListener('keydown', onAct, true)
    }
  }, [enabled, idleMs])

  return enabled && hidden
}
